import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4 d-flex align-items-center" }
const _hoisted_2 = { class: "dialog-custom__title m-0" }
const _hoisted_3 = { class: "bt-icon bt-icon--xs" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = {
  key: 0,
  class: "dialog-custom__content form-custom m-0"
}
const _hoisted_6 = { style: {"width":"450px","height":"calc(100vh - 330px)"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "p-field-label" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "p-field-label" }
const _hoisted_11 = {
  key: 1,
  style: {"width":"450px","height":"calc(100vh - 330px)"},
  class: "dialog-custom__content form-custom m-0 centered-container"
}
const _hoisted_12 = { class: "p-field-label" }
const _hoisted_13 = { class: "bt-icon bt-icon--xs" }
const _hoisted_14 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom invite-residents_dialog"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.showImportSection
                        ? _ctx.$t("entrancePlant.importResidentsTitle")
                        : _ctx.$t("AppResourceEP.InviteTheResidents")), 1),
        (!_ctx.showImportSection)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-text ml-auto",
              onClick: _ctx.handleImportClick
            }, {
              default: _withCtx(() => [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: require(`@/assets/images/icons/icon-import.svg`),
                    "aria-label": "icon-import"
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("entrancePlant.import")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.showImportSection)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_TabView, { class: "p-tabview--custom" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentEntrancePlant.buildings, (building, index) => {
                    return (_openBlock(), _createBlock(_component_TabPanel, {
                      key: index,
                      header: _ctx.tabBuildingLabel(building),
                      class: "apartment-list"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ElScrollbar, null, {
                          default: _withCtx(() => [
                            (
                                    _ctx.currentEntrancePlant.addressingType ===
                                    _ctx.AddressingType.BuildingRiserFloorApartment
                                )
                              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.buildingStructure(building), (riser, riserIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: riserIndex,
                                    class: "p-field"
                                  }, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(riser.floors, (floorsection, floorIndex) => {
                                      return (_openBlock(), _createBlock("div", {
                                        key: floorIndex,
                                        class: "p-field"
                                      }, [
                                        _createVNode("h6", null, _toDisplayString(riser.riser.name) + " - " + _toDisplayString(floorsection.floor.name), 1),
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(floorsection.apartments, (apartment, aptIndex) => {
                                          return (_openBlock(), _createBlock("div", {
                                            key: aptIndex,
                                            class: "p-field"
                                          }, [
                                            (apartment.apartmentId)
                                              ? (_openBlock(), _createBlock("span", _hoisted_7, [
                                                  _createVNode("label", _hoisted_8, _toDisplayString(_ctx.apartmentInputLabel(
                                                            apartment
                                                        )), 1),
                                                  _createVNode(_component_InputText, {
                                                    disabled: 
                                                        _ctx.disableInput(
                                                            apartment.apartmentId
                                                        )
                                                    ,
                                                    type: "email",
                                                    class: "w-100",
                                                    placeholder: 
                                                        _ctx.$t(
                                                            'AppResourceEP.InsertTheEmail'
                                                        )
                                                    ,
                                                    modelValue: 
                                                        _ctx.emailInput[
                                                            apartment
                                                                .apartmentId
                                                        ].email
                                                    ,
                                                    "onUpdate:modelValue": ($event: any) => (
                                                        _ctx.emailInput[
                                                            apartment
                                                                .apartmentId
                                                        ].email
                                                     = $event)
                                                  }, null, 8, ["disabled", "placeholder", "modelValue", "onUpdate:modelValue"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(building.apartments, (apartment, apartmentIndex) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: apartmentIndex,
                                    class: "p-field"
                                  }, [
                                    (apartment.apartmentId)
                                      ? (_openBlock(), _createBlock("span", _hoisted_9, [
                                          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.apartmentInputLabel(apartment)), 1),
                                          _createVNode(_component_InputText, {
                                            disabled: 
                                                _ctx.disableInput(
                                                    apartment.apartmentId
                                                )
                                            ,
                                            type: "email",
                                            class: "w-100",
                                            placeholder: 
                                                _ctx.$t(
                                                    'AppResourceEP.InsertTheEmail'
                                                )
                                            ,
                                            modelValue: 
                                                _ctx.emailInput[
                                                    apartment.apartmentId
                                                ].email
                                            ,
                                            "onUpdate:modelValue": ($event: any) => (
                                                _ctx.emailInput[
                                                    apartment.apartmentId
                                                ].email
                                             = $event)
                                          }, null, 8, ["disabled", "placeholder", "modelValue", "onUpdate:modelValue"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["header"]))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showImportSection)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("entrancePlant.importResidentsSubtitle").toUpperCase()), 1),
            _createVNode(_component_Button, {
              onClick: _ctx.triggerFilePicker,
              class: "p-button-rounded p-button-outlined"
            }, {
              default: _withCtx(() => [
                _createVNode("input", {
                  type: "file",
                  id: "fileInput",
                  style: {"display":"none"},
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
                  accept: ".csv"
                }, null, 32),
                _createVNode("span", _hoisted_13, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: require(`@/assets/images/icons/icon-import.svg`),
                    "aria-label": "icon-import"
                  }, null, 8, ["src"])
                ]),
                _createVNode("span", null, _toDisplayString(_ctx.$t("entrancePlant.import")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("footer", _hoisted_14, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.$t('AppResourceEP.InviteUpper'),
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m"
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}